import React from 'react'

export enum HelpType {
    NOTIFICATION    = 'notification',
    QUICK_LINK      = 'quick-link',
    HELP_CENTER     = 'help-center',
    IMPORTANT       = 'important',
}

type Props = {
    className?  : string
    iconClass?  : string
    style?      : any

    type        : HelpType
    noIcon?     : boolean

    children    : any
}

export default function HelpBlock(props: Props) {

    let icon : string
    let bgClass : string

    switch (props.type) {
        case HelpType.QUICK_LINK:
            icon = 'isvg-ico-quick-link'
            bgClass = 'quick-link-type'
            break
        case HelpType.NOTIFICATION:
            icon = 'isvg-ico-notification'
            bgClass = 'notification-type'
            break
        case HelpType.IMPORTANT:
            icon = 'isvg-ico-important'
            bgClass = 'notification-type'
            break

        case HelpType.HELP_CENTER:
        default:
            icon = 'isvg-ico-help-center'
            bgClass = 'help-center-type'
            break
    }
    // '{0}-type'.f(props.type)

    return (
        <div className={Classes("info-hint",bgClass, props.className)} style={props.style}>
            {!props.noIcon &&
                <div className="flex-row-left-top w-50">
                    <div className={Classes(props.iconClass, "w-30 h-36", icon)}/>
                </div>}

            <div className="w-100-percent min-w-0 ui5-txt-less-important lh-14em">
                {props.children}
            </div>
        </div>
    )
}
